function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "illus/entity/lawyer_v2"
}, React.createElement("path", {
  id: "path",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.907 26.6665C10.4656 26.6665 7.21557 22.8867 7.21557 18.4452C7.21557 16.7034 9.98563 15.2989 11.1808 14.7739C11.5289 14.6211 11.9166 14.5992 12.2862 14.688C13.2424 14.9179 13.8688 15.8351 13.7351 16.8094L12.9574 22.4743C12.8982 22.9055 13.2333 23.2898 13.6685 23.2898C14.0669 23.2898 14.3891 23.6143 14.3863 24.0127L14.384 24.3298C14.3799 24.9031 14.8435 25.3699 15.4167 25.3699H15.9407H16.5654C17.1592 25.3699 17.6405 24.8885 17.6405 24.2948V24.007C17.6405 23.6033 17.9533 23.2687 18.3561 23.2415C18.7998 23.2115 19.1251 22.8119 19.0646 22.3714L18.2928 16.7537C18.1576 15.7698 18.8155 14.852 19.7907 14.6641C20.126 14.5995 20.471 14.6263 20.7844 14.7619C21.9455 15.2644 24.8064 16.6821 24.8064 18.4523C24.8064 22.8934 21.5427 26.6665 17.1017 26.6665H14.907ZM19.8723 10.4089C19.8723 12.4757 18.1883 14.1508 16.1107 14.1508C14.0316 14.1508 12.3481 12.4752 12.3481 10.4089C12.3481 8.34162 14.0316 6.6665 16.1107 6.6665C18.1883 6.6665 19.8723 8.34162 19.8723 10.4089Z",
  fill: "#303030"
}));

var SvgLawyer = function SvgLawyer(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,";
export { SvgLawyer as ReactComponent };